import {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
    Box,
    Collapse,
    IconButton,
    LinearProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import Rating from '@material-ui/lab/Rating';
import AddIcon from '@material-ui/icons/Add';
import NuevaBitacora from './ModalNvoBit';
 
import CreateIcon from '@material-ui/icons/Create';
import {AuthContext} from '../context/AuthContext'
import {celda} from '../Generales/TablaGeneral';
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';
import {findNumber} from "../funciones/FindNumber";
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 420,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaActividades({orden,  listStatus, listTipo}) {
    const classes = useStyles();
    const nvlSNPermiso = '5'
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxColor=process.env.REACT_APP_COLOR    
    const idusu= localStorage.getItem('UsuId');
    const [selectedID, setSelectedID] = useState(null);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(false)
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [open, setOpen] = useState(false);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [selectActividad, setSelectActividad] = useState([])
    const [modalAbierto2, setModalAbierto2] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const {usuario} = useContext(AuthContext);
    const [espera, setEspera] = useState(false)

    useEffect(() => {
     


        setSelectedID('')

        getList()
        return () => {
            source.cancel();
        }
    }, [orden,actualizar]);

    const getList = () => {
        const data = qs.stringify({
            Usuario: idusu,
            Llave:orden.Id,
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/vigilancia/bitacora";

        function respuestaListAct(auxiliar) {
            if (auxiliar[0].Id !== -1) {
                guardarSinDatos(false)
                guardarDatos(auxiliar)
            } else {
                guardarSinDatos(true)
            }
        }

        llamaApiCargaToken(data, url, respuestaListAct, ErrorGeneral, setEspera, history, source);
    };

    const funcionActuliza=()=>{
        setActualizar(!actualizar)
    }

    const OrdenarFecha = (auxfecha) => {
        let modificada2 = moment.utc(auxfecha).local(true).format("DD/MM/YYYY HH:mm");
        return modificada2
    }

    function verMas(auxId) {
        if (auxId === ordenSelecc) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    function nuevaActiv() {
        setModalAbierto(true)
    }

    function editarActiv(auxFalla) {
        setSelectActividad(auxFalla)
        setModalAbierto2(true)
    }

    function tipoEstado(auxColor, idSelecc, auxEtiqueta) {
      /*   let auxEtiqueta = ''
        let auxColor = ''
        if (estado === 1) {
            auxEtiqueta = 'Registrado'
            auxColor = '#F46239'
        } else {
            if (estado === 3) {
                auxEtiqueta = 'Solucionado'
                auxColor = '#049b4f'
            } else {
                if (estado === 0) {
                    auxEtiqueta = 'Cancelado'
                    auxColor = 'red'
                }
            }
        } */
        let renglon = <div></div>
        selectedID === idSelecc ?
            renglon =
                <TableCell align="center" style={{color: 'white', fontWeight: 700, width: "8rem" + 'px'}} padding={'none'}>
                    {auxEtiqueta}
                </TableCell> :
            renglon = <TableCell align="center" style={{color: auxColor, fontWeight: 700, width: "8rem"}}
                                 padding={'none'}>{auxEtiqueta}</TableCell>
        return renglon
    }
 
    function Row(props) {
        const {row} = props;
        let estiloFolio = {
            color: selectedID === row.Id ? 'white' : '#0AC15D',
            fontWeight: '980',
            fontSize: 18,
            width: 10 + 'px'
        }
        let radioPrioridad = <Rating name="rating-prioridad" value={row.prioridad} size="small" max={3} readOnly
                                     style={{color: selectedID === row.Id ? 'white' : auxColor}}/>
        return (
            <>
                <TableRow
                    onClick={() => {
                        setSelectedID(row.Id);
                    }}
                    selected={selectedID === row.Id}
                    classes={{hover: classes.hover, selected: classes.selected}}
                    className={classes.tableRow}
                >
              {/*       <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                        <Tooltip title={open && ordenSelecc === row.Id ? 'Ver menos' : 'Ver más'}>
                            <IconButton color="primary" aria-label="expand row" size="small"
                                        onClick={() => verMas(row.Id)}>
                                {open && ordenSelecc === row.Id ? (selectedID === row.Id ?
                                        <KeyboardArrowUpIcon style={{color: 'white'}}/> : <KeyboardArrowUpIcon/>) :
                                    selectedID === row.Id ? <KeyboardArrowDownIcon style={{color: 'white'}}/> :
                                        <KeyboardArrowDownIcon/>}
                            </IconButton>
                        </Tooltip>
                    </TableCell> */}
                  {/*   <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                        <Tooltip title={'Editar'}>
                            <IconButton aria-label="add circle" size="small" onClick={() => editarActiv(row)}
                                        component="span">
                                {selectedID === row.Id ? <CreateIcon style={{color: 'white'}}/> :
                                    <CreateIcon color="primary"/>}
                            </IconButton>
                        </Tooltip>
                    </TableCell> */}
                    
                    {celda("center", {width:"7rem"}, row.TpNom, 2, classes.tableCell)}
                    {celda("center", {
                        width: 8+ 'rem',
                        paddingLeft: 5 + 'px'
                    }, OrdenarFecha(row.FReg), 3, classes.tableCell)}
                    {tipoEstado(row.StCol, row.Id, row.StNom)}
                    {celda("left", {width:"22rem"}, row.Nota, 4, classes.tableCell)}
                    
 
                </TableRow>
       
            </>
        );
    }

    const celdaVacia = <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
    const tablaCompleta = () => {

        return (<TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                           {/*  <TableCell align="left" padding={'none'}></TableCell> */}
                            
                            <TableCell align="center" padding={'none'}>Tipo </TableCell>
                            <TableCell align="center" padding={'none'}>Fecha</TableCell>
                            <TableCell align="center" padding={'none'}>Estatus</TableCell>
                            <TableCell align="left" padding={'none'}>Descripción</TableCell>
                            
                       
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {usuario?.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
                            <TableRow className={classes.tableRow}>
                                <TableCell className={classes.tableCell} align="left" padding={'none'}
                                           style={{width: 30 + 'px'}}>
                                    {findNumber('|2|') ? 
                                        <Tooltip title={'Agregar Bitacora'}>
                                            <IconButton aria-label="agregar-Bitacora" size="small"
                                                onClick={() => nuevaActiv()} component="span">
                                                <AddIcon color="primary"/>
                                            </IconButton>
                                        </Tooltip>
                                    : null}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="left" padding={'none'}
                                    style={{fontWeight: 700, color: auxColor}}>
                                    {findNumber('|2|') ?  'Nueva' : ""} 
                                </TableCell>
                                <TableCell className={classes.tableCell} align="center" padding={'none'} style={{
                                    paddingLeft: 5 + 'px',
                                    fontWeight: 700,
                                    color: auxColor
                                }}>{findNumber('|2|') ?  'Bitacora' : ""}</TableCell>
                             
                                {celdaVacia}
                                {celdaVacia}
                                {celdaVacia}
                                {celdaVacia}
                            </TableRow>
                            : null
                        }
                        {datos.length !== 0 ? (datos.map((row) => (
                            <Row key={row.Id} row={row}/>
                        ))) : null}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
    const tablaSinDatos = () => {
        return (<TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" padding={'none'}>Folio </TableCell>
                            <TableCell align="center" padding={'none'}>Fecha</TableCell>
                 
                            <TableCell align="left" padding={'none'}>Tipo</TableCell>
                            <TableCell align="left" padding={'none'}>Descripción</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {usuario?.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
                            <TableRow className={classes.tableRow}>
                                <TableCell className={classes.tableCell} align="center" padding={'none'}
                                    style={{width: 40 + 'px', paddingLeft: 10 + 'px'}}>
                                    {findNumber('|2|') ? 
                                        <IconButton aria-label="agregar-Bitacora" size="small" 
                                            onClick={() => nuevaActiv()} component="span">
                                            <AddIcon color="primary"/>
                                        </IconButton>
                                     : null}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="center" padding={'none'}
                                           style={{
                                               width: 120 + 'px',
                                               paddingLeft: 5 + 'px',
                                               fontWeight: 700,
                                               color: auxColor
                                           }}>
                                      {findNumber('|2|') ?  'Nueva' : ""}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="center" padding={'none'}
                                           style={{
                                               width: 30 + 'px',
                                               paddingLeft: 5 + 'px',
                                               fontWeight: 700,
                                               color: auxColor
                                           }}>
                                    {findNumber('|2|') ?  'Bitacora' : ""}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
                                <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>
                            </TableRow>
                            : null
                        }
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell} align="left" padding={'none'}
                                       style={{width: 30 + 'px'}}>
                            </TableCell>
                            <TableCell className={classes.tableCell} align="center" padding={'none'}
                                       style={{width: 120 + 'px', paddingLeft: 5 + 'px'}}>Reporte </TableCell>
                            <TableCell className={classes.tableCell} align="center" padding={'none'}
                                       style={{width: 120 + 'px', paddingLeft: 5 + 'px'}}>Sin</TableCell>
                            <TableCell className={classes.tableCell} align="left"
                                       padding={'none'}>Bitacora</TableCell>                            
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
    const contenido = !sinDatos ? tablaCompleta() : tablaSinDatos()
    const cargando = !espera ? contenido : <Box my={2}><LinearProgress/></Box>
    const modal = modalAbierto ?
        (usuario?.nivel !== undefined && usuario.nivel !== nvlSNPermiso ?
                (<NuevaBitacora titulo={'Nueva Bitacora'} modalAbierto={modalAbierto}
                    setModalAbierto={setModalAbierto} auxOrden={orden}
                    actualizar={funcionActuliza} listStatus={listStatus} listTipo={listTipo}
                />)
                : null
        )
        : null
 
    return (
        <Paper className={classes.root}>
            {cargando}
        {modal}
        </Paper>
    );
}
